/**
 * @file index.tsx
 *
 * @fileoverview Renders blog simple text row.
 */

import { WYSIWYGText } from '~/vcl/atoms/13-text/02-WYSIWYG';

interface BlogSimpleTextRowProps {
  /**
   * The text to display.
   */
  text: string;
}
export default function BlogSimpleTextRow({ text }: BlogSimpleTextRowProps) {
  return <WYSIWYGText format="full_html" content={text} />;
}

export { BlogSimpleTextRow };
